module.exports = __webpack_public_path__ + "img/dashboard.fe763a09.svg";